import {NotFoundComponent, TranslateUtils} from '@wallaby-ui/core';
import classNames from 'classnames';
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {defineMessages, useIntl} from 'react-intl';

import stylesLayout from './AppLayout.less';
import styles from './NotFoundComponentBox.less';

const I18N = defineMessages({
  PAGE_TITLE: {
    id: 'notFound.pageTitle',
    defaultMessage: 'Page not found',
    description: 'title for not found page',
  },
});

interface OwnProps {
  hideHelmet?: boolean;
}

type Props = OwnProps;

export const NotFoundComponentBox: React.FC<Props> = (props) => {
  const {hideHelmet = false} = props;
  const intl = useIntl();
  return (
    <div className={stylesLayout.dlTabColumnWrapper}>
      {hideHelmet ? null : <Helmet title={TranslateUtils.translate(I18N.PAGE_TITLE, intl)} />}
      <div
        className={classNames({
          [stylesLayout.dlCenterColumn]: true,
        })}
      >
        <NotFoundComponent className={styles.dlNotFoundComponentBox} />
      </div>
    </div>
  );
};

NotFoundComponentBox.displayName = 'NotFoundComponentBox';
